// stores/detail.ts
import { defineStore } from 'pinia'
import { ref, computed } from 'vue'
import { useTheme } from 'vuetify'

export const useDetailStore = defineStore('detailStore', () => {
  /**
   * 다크모드 상태 (true: dark, false: light)
   */
  const isDark = ref<boolean>(true)

  // Vuetify 테마 제어
  const theme = useTheme();

  const getIsDark = computed(() => isDark.value)

  function setIsDark(payload: boolean) {
    isDark.value = payload
    // Vuetify 테마 업데이트
    theme.global.name.value = isDark.value ? 'dark' : 'light'
  }

  function toggleDark() {
    isDark.value = !isDark.value
    // Vuetify 테마 업데이트
    theme.global.name.value = isDark.value ? 'dark' : 'light'
  }

  function resetIsDark() {
    isDark.value = false
    // Vuetify 테마 업데이트
    theme.global.name.value = 'light'
  }

  return {
    isDark,
    getIsDark,
    setIsDark,
    toggleDark,
    resetIsDark
  }
})